import { render, staticRenderFns } from "./icon-tif.vue?vue&type=template&id=4530c8a9&"
import script from "./icon-tif.vue?vue&type=script&lang=js&"
export * from "./icon-tif.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports